(function () {
  var EMAIL_KEY = 'sunkis-ea-v2-email';
  var STEP_KEY = 'sunkis-ea-v2-step';
  var PENDING_KEY = 'sunkis-ea-v2-pending-bump';
  var SPOTS_KEY = 'sunkis-ea-v3-spots';
  var COUNTED_KEY = 'sunkis-ea-v2-counted';
  var DISMISS_KEY = 'sunkis-early-access-popup-dismissed';

  var hero = document.querySelector('[data-sk-ea-hero]');
  if (!hero) return;

  var total = Number(hero.getAttribute('data-spots-total') || 20000);
  var baseReserved = Number(hero.getAttribute('data-spots-reserved') || 8926);
  var reserved = baseReserved;
  function readSpots() {
    var stored = 0;
    try {
      stored = Number(localStorage.getItem(SPOTS_KEY) || sessionStorage.getItem(SPOTS_KEY) || 0);
    } catch (e) {}
    var m = document.cookie.match(/(?:^|; )sunkis_ea_spots=(\d+)/);
    if (m) stored = Math.max(stored, Number(m[1]));
    return stored;
  }
  var storedSpots = readSpots();
  if (storedSpots > reserved) reserved = storedSpots;

  var fillEl = document.querySelector('[data-sk-ea-fill]');
  var pctEl = document.querySelector('[data-sk-ea-pct]');
  var countEl = document.querySelector('.sk-ea-spots__count');

  function renderSpots() {
    reserved = Math.min(reserved, total);
    var pct = total ? (reserved / total) * 100 : 0;
    if (countEl) {
      countEl.hidden = false;
      countEl.innerHTML =
        '<span data-sk-ea-reserved>' +
        reserved.toLocaleString('en-US') +
        '</span> / ' +
        total.toLocaleString('en-US') +
        ' reserved';
    }
    if (fillEl) fillEl.style.width = pct.toFixed(1) + '%';
    var bar = document.getElementById('sk-ea-progress');
    if (bar) bar.hidden = false;
    if (pctEl) {
      pctEl.hidden = false;
      pctEl.textContent = pct.toFixed(1) + '% claimed';
    }
  }

  function saveSpots() {
    try {
      localStorage.setItem(SPOTS_KEY, String(reserved));
      sessionStorage.setItem(SPOTS_KEY, String(reserved));
    } catch (e) {}
    document.cookie = 'sunkis_ea_spots=' + reserved + ';path=/;max-age=31536000;SameSite=Lax';
  }

  function bumpOnce() {
    if (window.__skEaBump) {
      window.__skEaBump();
      reserved = readSpots() || reserved;
      renderSpots();
      return true;
    }
    if (window.__skEaDid) return false;
    window.__skEaDid = true;
    reserved += 1;
    saveSpots();
    renderSpots();
    return true;
  }

  var signup = document.getElementById('sk-ea-signup');
  var offer = document.querySelector('[data-sk-ea-offer]');
  var emailInput = document.getElementById('sk-ea-email');
  var phoneInput = document.getElementById('sk-ea-phone-input');
  var noteInput = document.getElementById('sk-ea-note-phone');
  var tagsInput = document.getElementById('sk-ea-tags');
  var emailMsg = document.querySelector('[data-sk-ea-email-msg]');
  var phoneMsg = document.querySelector('[data-sk-ea-phone-msg]');
  var nextBtn = document.querySelector('[data-sk-ea-next]');
  var baseTags = (hero.getAttribute('data-form-tags') || 'newsletter,waitlist,sunkis-early-access');

  function showEmail() {
    if (offer) offer.classList.remove('is-phone', 'is-reserved');
    if (emailInput) emailInput.disabled = false;
  }

  function showPhone() {
    if (offer) {
      offer.classList.add('is-phone');
      offer.classList.remove('is-reserved');
    }
    closePopup();
  }

  function showDone() {
    if (offer) {
      offer.classList.add('is-reserved');
      offer.classList.remove('is-phone');
    }
    if (emailInput) emailInput.disabled = true;
    closePopup();
  }

  function setMsg(el, text, isError) {
    if (!el) return;
    el.textContent = text || '';
    el.className = 'sk-ea-msg' + (isError ? ' sk-ea-msg--error' : '');
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  var SPOTS_GET = 'https://abacus.jasoncameron.dev/get/sunkisco/earlyaccess';
  var SPOTS_HIT = 'https://abacus.jasoncameron.dev/hit/sunkisco/earlyaccess';

  var spotsReq = 0;

  function applyServerCount(value, req) {
    if (req < spotsReq) return;
    spotsReq = req;
    var n = Number(value);
    if (!n) return;
    reserved = n;
    saveSpots();
    renderSpots();
  }

  function loadServerSpots() {
    var req = ++spotsReq;
    fetch(SPOTS_GET + '?t=' + Date.now())
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && typeof data.value === 'number') applyServerCount(data.value, req);
      })
      .catch(function () {});
  }

  function armSpotHit() {
    var id = String(Date.now());
    try { sessionStorage.setItem('sunkis-ea-arm', id); } catch (e) {}
    document.cookie = 'sunkis_ea_arm=' + id + ';path=/;max-age=600;SameSite=Lax';
  }

  function consumeSpotHit() {
    var posted = /(?:^|[?&])form_posted=1(?:&|$)/.test(window.location.search);
    if (!posted || window.__skEaConsumed) return;
    var id = '';
    try { id = sessionStorage.getItem('sunkis-ea-arm') || ''; } catch (e) {}
    if (!id) {
      var m = document.cookie.match(/(?:^|; )sunkis_ea_arm=(\d+)/);
      if (m) id = m[1];
    }
    if (!id) return;
    var used = '';
    try { used = localStorage.getItem('sunkis-ea-used') || ''; } catch (e) {}
    if (used === id) return;
    window.__skEaConsumed = true;
    try { localStorage.setItem('sunkis-ea-used', id); } catch (e) {}
    try { sessionStorage.removeItem('sunkis-ea-arm'); } catch (e) {}
    document.cookie = 'sunkis_ea_arm=;path=/;max-age=0;SameSite=Lax';
    var req = ++spotsReq;
    fetch(SPOTS_HIT + '?t=' + id)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && typeof data.value === 'number') applyServerCount(data.value, req);
      })
      .catch(function () {});
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('form_posted');
      history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (e) {}
  }
  function bindCaptchaSubmit(form, prepare) {
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (prepare && prepare(e) === false) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      try {
        sessionStorage.setItem(PENDING_KEY, '1');
        sessionStorage.setItem(STEP_KEY, 'done');
      } catch (err) {}
      armSpotHit();
    }, true);
  }

  var posted = /customer_posted=true|contact_posted=true/.test(window.location.search);
  var step = 'email';
  var pendingBump = false;
  try {
    step = sessionStorage.getItem(STEP_KEY) || 'email';
    pendingBump = sessionStorage.getItem(PENDING_KEY) === '1';
  } catch (e) {}

  try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
  if (posted) step = 'done';

  if (posted) step = 'done';

  if (step === 'done') showDone();
  else if (step === 'phone') showPhone();
  else showEmail();
  if (readSpots() > 0) renderSpots();
  loadServerSpots();
  consumeSpotHit();

  if (nextBtn && emailInput) {
    nextBtn.addEventListener('click', function () {
      var email = emailInput.value.trim();
      if (!isValidEmail(email)) {
        setMsg(emailMsg, 'Please enter a valid email address.', true);
        emailInput.focus();
        return;
      }
      setMsg(emailMsg, '', false);
      try {
        sessionStorage.setItem(EMAIL_KEY, email);
        sessionStorage.setItem(STEP_KEY, 'phone');
      } catch (e) {}
      showPhone();
    });
  }

  function prepareSubmit(includePhone) {
    var phone = phoneInput ? phoneInput.value.trim() : '';
    if (includePhone) {
      if (phone.replace(/\D/g, '').length < 10) {
        setMsg(phoneMsg, 'Please enter a valid phone number.', true);
        if (phoneInput) phoneInput.focus();
        return false;
      }
      if (noteInput) noteInput.value = phone;
      if (tagsInput) tagsInput.value = baseTags + ',sms';
    } else {
      if (noteInput) noteInput.value = '';
      if (phoneInput) phoneInput.value = '';
      if (tagsInput) tagsInput.value = baseTags;
    }
    try {
      sessionStorage.setItem(PENDING_KEY, '1');
      sessionStorage.setItem(STEP_KEY, 'done');
    } catch (e) {}
    return true;
  }

  if (signup) {
    bindCaptchaSubmit(signup, function (e) {
      var skip = e.submitter && e.submitter.hasAttribute('data-sk-ea-skip-phone');
      return prepareSubmit(!skip);
    });
  }

  var popupForm = document.getElementById('sk-ea-popup-form');
  var popupEmail = document.getElementById('sk-ea-popup-email');
  if (popupForm) {
    bindCaptchaSubmit(popupForm, function () {
      if (!popupEmail || !isValidEmail(popupEmail.value.trim())) {
        if (popupEmail) popupEmail.focus();
        return false;
      }
      try { sessionStorage.setItem(EMAIL_KEY, popupEmail.value.trim()); } catch (err) {}
      return true;
    });
  }

  var popup = document.getElementById('sk-ea-popup');
  function openPopup() {
    if (!popup) return;
    if (sessionStorage.getItem(DISMISS_KEY)) return;
    if (step === 'phone' || step === 'done') return;
    popup.hidden = false;
  }
  function closePopup() {
    if (!popup) return;
    popup.hidden = true;
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  }
  if (popup) {
    var delay = Number(hero.getAttribute('data-popup-delay') || 5) * 1000;
    var closeBtn = popup.querySelector('[data-sk-ea-close]');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) closePopup();
    });
    window.setTimeout(openPopup, delay);
  }

  document.querySelectorAll('.sk-ea-hero__media video, .sk-ea-hero__media video-component video').forEach(function (el) {
    el.muted = true;
    el.playsInline = true;
    el.play && el.play().catch(function () {});
  });
})();
